import { useTranslation } from "react-i18next";
import { QuestionAnswerBlock } from "./QuestionAnswerBlock";
import { HelpVideo } from "./HelpVideo";
import { useState } from "react";

export function Help() {
  const { t } = useTranslation();
  const [openIndices, setOpenIndices] = useState<number[]>([]);
  const faqs = t("faq.questions", { returnObjects: true }) as {
    question: string;
    answer: string;
  }[];

  const setIsOpened = (index: number, isOpened: boolean) => {
    if (isOpened) {
      setOpenIndices([...openIndices, index]);
    } else {
      setOpenIndices(openIndices.filter((i) => i !== index));
    }
  };

  return (
    <div className="max-w-[936px] w-full px-5 lg:px-0 mx-auto mt-6 md:mt-16 lg:mt-18 mb-6 md:mb-16 lg:mb-18 ">
      <div className="mb-6 md:mb-10">
        <HelpVideo />
      </div>
      <h1 className="text-cnam-blue font-jakarta text-[32px] md:text-[40px]">
        {t("faq.title")}
      </h1>

      <h2 className="font-jakarta text-[16px] md:text-[24px] text-text-strong mt-4 pb-2">
        {t("faq.subtitle")}
      </h2>

      <ul>
        {faqs.map((faq, index) => (
          <QuestionAnswerBlock
            key={faq.question}
            index={index}
            question={faq.question}
            answer={faq.answer}
            isOpened={openIndices.includes(index)}
            setIsOpened={setIsOpened}
            className={`border-b border-grey-blue-300 py-6 text-cnam-blue`}
          />
        ))}
      </ul>
    </div>
  );
}
